<div class="participants-list-container"></div>
<div class="search-container">
  <span class="title">{{ 'CHOOSE PEOPLE' | translate }}</span>
  <app-search-bar
    class="search-bar"
    [searchTitle]="'Search for participant by name' | translate"
    (filter)="onSearch($event)"
    [searchOnClear]="false"
    [searchContinuously]="true"
    [size]="searchBarSizeEnum.LARGE"
  >
  </app-search-bar>
</div>
<div
  class="list-items"
  appIntersectionObserveElement
  #intersection="intersection"
  (isLastElementInView)="loadMoreUsers()"
>
  <!--          hosts should be checked by default -->
  <div class="list-item">
    <div class="user-container">
      <svg-icon [height]="18" [width]="18" class="item-container" icon="shield"></svg-icon>
      <span>{{ 'All hosts' | translate }}</span>
    </div>
    <div class="item-container">
      <mat-checkbox
        class="check-box all-hosts-checkbox"
        [checked]="true"
        [disabled]="true"
      ></mat-checkbox>
    </div>
  </div>
  <!--          All Particpants only ( not hosts ) -->
  <div
    *ngFor="let user of shownFilteredParticipantsUsers$ | async; trackBy: trackByUserId"
    class="list-item"
  >
    <div class="user-container">
      <div class="item-container">
        <app-profile-photo
          [user]="user"
          width="30"
          fontSize="16"
          [isClickEnabled]="false"
        ></app-profile-photo>
      </div>
      <span> {{ user.name || user.email | truncateString: 40 }} </span>
    </div>
    <div class="item-container">
      <mat-checkbox
        class="check-box"
        [color]="'primary'"
        (change)="handleCheckboxForUser($event, user)"
        [checked]="selectedPrivateUsersForFrame.includes(user._id)"
        data-name="board-tab-board-options-change-access-selected-user"
      >
      </mat-checkbox>
    </div>
  </div>
</div>
